import { Injectable, EventEmitter } from '@angular/core';

@Injectable({
	providedIn: 'root',
})
export class MapService {
	cities: Array<any> = [];
	vehicles: Array<any> = [];
	transports: Array<any> = [];
	destinations: Array<any> = [];
	stops = {
		CR: [],
		DO: [],
	};
	template: Array<any> = [];

	vehiclesAll: Array<any> = [];

	vehicleSelected = null;
	citySelected = null;

	editable = false;
	changes = new EventEmitter();

	parse(transports): void {
		this.vehicles = [];
		transports.forEach((transport) => {
			const city = this.cities.find((objFind) => objFind.id == transport.city);
			let vehicle = this.vehicles.find((objFind) => objFind.id == transport.vehicle);
			if (!vehicle) {
				vehicle = this.vehiclesAll.find((objFind) => objFind.id == transport.vehicle);
				if (!vehicle) {
					return;
				}
				vehicle.occupied = 0;
				vehicle.crew = 0;
				vehicle.destinations = [];
				this.vehicles.push(vehicle);
			}
			let destination;
			switch (transport.action) {
				case 'BA':
					destination = city.destinations.find(
						(objFind) => objFind.id == transport.destination && objFind.originCity == transport.originCity,
					);
					this.boarding(destination, city, vehicle);
					break;
				case 'DO':
					destination = vehicle.destinations.find(
						(objFind) => objFind.id == transport.destination && objFind.originCity == transport.originCity,
					);
					this.dropoff(destination, vehicle, city);
					break;
				case 'CR':
					destination = this.destinations.find((objfind) => objfind.id == transport.destination);
					this.cruising(destination, vehicle, city);
					break;
				case 'TG':
					destination = this.destinations.find((objfind) => objfind.id == transport.destination);
					this.target(destination, vehicle);
					break;
			}
		});
		if (this.vehicles.length) {
			this.selectVehicle(this.vehicles[0]);
		}
	}

	boarding(destination, city, vehicle) {
		if (!destination) {
			destination = {
				from: [],
			};
		}
		destination.from.push(city.name);
		vehicle.destinations.push(destination);
		city.destinations.splice(city.destinations.indexOf(destination), 1);
		this.transferAdd(destination, city, vehicle, 'BA');
	}

	dropoff(destination, vehicle, city) {
		if (!destination) {
			destination = {
				from: [],
			};
		}
		destination.from.push(vehicle.name);
		city.destinations.push(destination);
		vehicle.destinations.splice(vehicle.destinations.indexOf(destination), 1);
		this.transferAdd(destination, city, vehicle, 'DO');
	}

	target(destination, vehicle): void {
		this.transferAdd(destination, destination, vehicle, 'TG');
	}

	cruising(destination, vehicle, city): void {
		this.transferAdd(destination, city, vehicle, 'CR');
	}

	private transferAdd(destination, city, vehicle, action) {
		this.transports.push({
			destination: destination,
			city: {
				id: city.id,
				name: city.name,
				type: city.type,
			},
			vehicle: {
				id: vehicle.id,
				name: vehicle.name,
			},
			action: action,
		});
		this.changes.emit({ type: 'transfer' });
	}

	boardingAll() {
		const count = this.citySelected.destinations.length - 1;
		for (let i = count; i >= 0; i--) {
			this.boarding(this.citySelected.destinations[i], this.citySelected, this.vehicleSelected);
		}
	}

	dropoffAll() {
		const count = this.vehicleSelected.destinations.length - 1;
		for (let i = count; i >= 0; i--) {
			this.dropoff(this.vehicleSelected.destinations[i], this.vehicleSelected, this.citySelected);
		}
	}

	reset() {
		this.cities = [];
		this.vehicles = [];
		this.transports = [];
		this.vehiclesAll = [];
		this.vehicleSelected = null;
		this.citySelected = null;
	}

	selectVehicle(vehicle) {
		this.vehicleSelected = vehicle;
		this.vehicles.map((obj) => {
			if (obj == vehicle) {
				obj.selected = true;
				return obj;
			}
			obj.selected = false;
			return obj;
		});
		this.changes.emit({ type: 'selectVehicle' });
	}

	stopToggle(item): void {
		const index = this.stops[item.type].findIndex((obj) => obj.id == item.data.id);
		if (index == -1) {
			// add
			this.stops[item.type].push(item.data);
			return;
		}
		// remove
		this.stops[item.type].splice(index, 1);
	}

	haveBorder(vehicle): boolean {
		return this.transports
			.filter((transport) => transport.vehicle.id == vehicle.id)
			.find((obj) => obj.city.type == 'BR')
			? true
			: false;
	}

	haveTarget(vehicle): boolean {
		return this.transports
			.filter((transport) => transport.vehicle.id == vehicle.id)
			.find((obj) => obj.action == 'TG')
			? true
			: false;
	}

	havePeople(vehicle): boolean {
		return vehicle.destinations.length ? true : false;
	}
}
